// extracted by mini-css-extract-plugin
export default {"container":"JK-z","dimension":"KK-z","dimensionLabels":"LK-z"};